let authTransitionsService = ($transitions, authService) => {
  return {
    init: () => {
      $transitions.onStart({}, transition => {
        if (transition.to().auth !== false) {
          return authService.checkLoggedIn();
        }
      });  
    }
  };
};

authTransitionsService.$inject = [ '$transitions', 'authService' ];

export default authTransitionsService;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth.transitions.service.js